<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="items"
      :class="{
        opened: opened.indexOf('changeStatus') >= 0,
        'last-active': opened.indexOf('changeStatus') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleStatusConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="changeStatus()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZmeny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>
          {{ $t("zmenitRezimU") }} {{ items.length }}
          <span v-if="items.length > 1">{{ $t("zarizeni") }}</span>
          <span v-else>{{ $t("zarizeni") }}</span>
        </h2>
      </div>
      <div class="side-box__content">
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("prepnoutDoRezimu") }}</span>
          <div class="side-box__content__input custom-control__select ml-3">
            <div
              :class="{ opened: tagsOpened }"
              class="custom-control__select__selected d-flex"
              @click="tagsOpened = tagsOpened ? false : true"
            >
              <div class="d-flex flex-wrap">
                <span v-if="selectedState == ''" class="gray-text">{{ $t("vyberteRezim") }}</span>
                <div v-else class="">
                  <div v-if="selectedState == 'RESUME'">
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--success mr-2">A</div>
                      <span>{{ $t("active") }}</span>
                    </div>
                  </div>
                  <div v-if="selectedState == 'SUSPEND'">
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--gray mr-2">S</div>
                      <span>{{ $t("SUSPENDED") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ opened: tagsOpened }" class="custom-control__select__options">
              <div
                class="custom-control__select__option d-flex align-items-center"
                @click="
                  () => {
                    selectedState = 'RESUME'
                    tagsOpened = tagsOpened = false
                  }
                "
              >
                <div class="d-flex">
                  <div class="atom-circle atom-circle--success mr-2">A</div>
                  <span>{{ $t("active") }}</span>
                </div>
              </div>
              <div
                class="custom-control__select__option d-flex align-items-center"
                @click="
                  () => {
                    selectedState = 'SUSPEND'
                    tagsOpened = tagsOpened = false
                  }
                "
              >
                <div class="d-flex">
                  <div class="atom-circle atom-circle--gray mr-2">S</div>
                  <span>{{ $t("SUSPENDED") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedStatusConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleStatusConfirmation"
      @no="closeBox()"
      @yes="changeStatus()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    tags: Array,
    opened: Array,
    items: Array
  },
  data() {
    return {
      tagsOpened: false,
      selectedState: "",
      openedStatusConfirmation: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  watch: {
    project() {}
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    setProject() {},
    resetValues() {
      this.selectedState = ""
    },

    changeStatus() {
      this.errorsToTranslate = []

      this.showWaiting()
      let promises = []
      this.items.forEach((item) => {
        promises.push(
          axios
            .post(process.env.VUE_APP_API + "/simcards/service/" + item.custServiceId + "/" + item.iccid + "/status", {
              action: this.selectedState
            })
            .then(() => {})
            .catch((error) => {
              this.errorsToTranslate.push(error.data)
            })
        )
      })
      Promise.all(promises).then(() => {
        this.openedError = true
        let cacheUpdateAt = new Date()
        cacheUpdateAt.setSeconds(cacheUpdateAt.getSeconds() + 30)
        localStorage.setItem("simcardsCacheUpdateAt", cacheUpdateAt)
        this.$emit("reloadSimcards")
        this.$emit("info")
        this.hideWaiting()
        this.closeBox()
      })
    },
    toggleStatusConfirmation() {
      this.openedStatusConfirmation = this.openedStatusConfirmation ? false : true
    },
    showWaiting() {
      console.log("showWaiting")
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
    },
    hideWaiting() {
      this.$store.commit("modals/setWaitingLoader", "")
    }
  }
}
</script>

<style lang="scss" scoped></style>
